<template>
  <div>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text"> Macchine </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="dialog_nuova_macchina = true"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="primary"> mdi-plus </v-icon>
          </v-btn>
        </template>
        <span>Aggiungi Macchina</span>
      </v-tooltip>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-data-table
      dense
      height="45vh"
      :headers="headers_macchine"
      :items="macchine_lista"
      fixed-header
      class="elevation-1 pt-0"
    >
      <!-- Colonna del delete -->
      <template v-slot:[`item.delete`]="{ item }">
        <v-btn
          @click="aggiungiListaRimossi(item)"
          small
          v-model="item.cancellato"
          ><v-icon color="error">mdi-close</v-icon></v-btn
        >
      </template>
    </v-data-table>
    <!-- DIALOG AGGIUNGI MACCHINA -->
    <v-dialog v-model="dialog_nuova_macchina" max-width="600px">
      <v-card>
        <v-toolbar
          class="white--text"
          color="indigo"
          style="position: sticky; top: 0px; z-index: 1"
          dense
        >
          <v-toolbar-title>Aggiungi macchina</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="aggiungiMacchinaTemp"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Aggiungi al reparto</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_nuova_macchina = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Annulla</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5 mb-0 pb-5">
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                background-color="#ffffff"
                hide-details
                multiple
                :items="
                  macchine_lista_extra.filter(
                    (m) =>
                      macchine_lista.filter(
                        (m2) => m2.id_macchina == m.id_macchina
                      ).length == 0
                  )
                "
                return-object
                item-value=""
                :item-text="(e) => e.des_macchina"
                label="Macchina"
                style="display: inline-block; max-width: 350px"
                v-model="macchine_aggiunte"
              >
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "",

  components: {},

  props: ["id_reparto"],

  data() {
    return {
      // Variabili d'appoggio

      // Modal
      dialog_nuova_macchina: false,

      // Array
      headers_macchine: new Array(),
      macchine_lista: new Array(),
      macchine_lista_extra: new Array(),
      macchine_aggiunte: new Array(),
      macchine_rimosse: new Array(),
      macchine_da_salvare: new Array(),
    };
  },

  computed: {},

  watch: {},

  methods: {
    aggiungiListaRimossi(item) {
      item.id_reparto = null;
      this.macchine_rimosse.push(item);
      this.macchine_lista.splice(this.macchine_lista.indexOf(item), 1);
    },

    getListaMacchine() {
      this.headers_macchine = [
        {
          text: "Nome",
          value: "des_macchina",
        },
        {
          text: "Codice",
          value: "cod_macchina",
        },
        {
          text: "Specifiche",
          value: "specifiche",
        },
        {
          text: "Rimuovi",
          value: "delete",
        },
      ];

      const getlistamacchine = {
        controller: "Manutenzione",
        method: "POST",
        richiesta: {
          action: "getlistamacchine",
          token: localStorage.getItem("user_token"),
        },
      };

      this.$store.dispatch("api", getlistamacchine).then((res) => {
        if (res.status === 200) {
          this.macchine_lista = [];
          this.macchine_lista_extra = [];
          res.data.macchine.forEach((e) => {
            if (e.id_reparto == this.id_reparto) {
              this.macchine_lista.push(e);
            } else {
              this.macchine_lista_extra.push(e);
            }
          });
          console.log(this.macchine_lista);
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
          );
        }
      });
    },

    aggiungiMacchinaTemp() {
      for (let j = 0; j < this.macchine_aggiunte.length; j++) {
        this.macchine_aggiunte[j].id_reparto = this.id_reparto;
      }
      this.macchine_aggiunte.forEach((e) => {
        this.macchine_lista.push(e);
        this.macchine_da_salvare.push(e);
      });

      this.macchine_aggiunte = [];
      this.dialog_nuova_macchina = false;
    },

    aggiungiMacchina() {
      // Da chiamare nel salva di dettaglio reparto
      let array_tmp = new Array();

      array_tmp = this.macchine_da_salvare;

      array_tmp.forEach((e) => {
        e.validita = 1;
      });

      if (array_tmp.length != 0) {
        let richiesta = {
          controller: "Manutenzione",
          method: "PUT",
          richiesta: {
            action: "updatemacchina",
            token: localStorage.getItem("user_token"),
            tabella: array_tmp,
          },
        };

        this.$store.dispatch("api", richiesta).then((res) => {
          if (res.status === 200) {
            this.getListaMacchine();
            this.dialog_nuova_macchina = false;
            this.macchine_da_salvare = [];
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
            );
          }
        });
      }
    },

    rimuoviMacchina() {
      this.macchine_rimosse.forEach((m) => {
        m.validita = 1;
      });

      if (this.macchine_rimosse.length != 0) {
        let richiesta = {
          controller: "Manutenzione",
          method: "PUT",
          richiesta: {
            action: "updatemacchina",
            token: localStorage.getItem("user_token"),
            tabella: this.macchine_rimosse,
          },
        };

        this.$store.dispatch("api", richiesta).then((res) => {
          if (res.status === 200) {
            this.macchine_rimosse = [];
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
            );
          }
        });
      }
    },
  },

  created() {},

  mounted() {
    this.getListaMacchine();
  },
};
</script>

<style scoped>
</style>